import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp, unwrapEdges } from 'src/lib/graphql';
import type {
  BackendQueryWorkspacesArgs,
  BackendWorkspace,
  BackendWorkspaceConnection,
} from 'src/types/backend';

import { FRAGMENT_BRAND_VOICE, FRAGMENT_BRAND_VOICE_ASSETS } from './schema';

const QUERY = gql`
  query BrandVoicesAssets($customerId: ID!, $id: ID) {
    workspaces(customerId: $customerId, id: $id) {
      edges {
        node {
          associatedBrandVoices {
            ...BrandVoice
            ...BrandVoiceAssets
          }
        }
      }
    }
  }
  ${FRAGMENT_BRAND_VOICE}
  ${FRAGMENT_BRAND_VOICE_ASSETS}
`;

type Variables = Pick<BackendQueryWorkspacesArgs, 'customerId' | 'id'>;

interface Options {
  abortSignal?: AbortSignal;
}

export const queryWorkspaceBrandVoicesAssets = async (variables: Variables, options?: Options) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  const workspaces = getSingleProp<BackendWorkspaceConnection>(result.data);
  const nodes = unwrapEdges<BackendWorkspace>(
    workspaces?.edges as Array<{ node: BackendWorkspace }> | undefined
  );
  return nodes?.[0]?.associatedBrandVoices;
};
